import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPage from "../pages/privacy/page";
import RodoPage from "../pages/rodo/page";
import TermsPage from "../pages/terms/page";
import CookiesPage from "../pages/cookies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/polityka-prywatnosci",
    element: <PrivacyPage />,
  },
  {
    path: "/rodo",
    element: <RodoPage />,
  },
  {
    path: "/regulamin",
    element: <TermsPage />,
  },
  {
    path: "/polityka-cookies",
    element: <CookiesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
